import React from "react";
import "./CTA.css";
function CTA() {
  return (
    <aside className="gpt3__cta section__margin">
      <div className="gpt3__cta-content">
        <p>Request Early Access to Get Started</p>
        <h3>Register today & start exploring the endless possiblities.</h3>
      </div>
      <div className="gpt3__cta-btn">
        <button type="button">Get Started</button>
      </div>
    </aside>
  );
}

export default CTA;
